/**
 * Created by Slava on 21.10.2024
 */

ExclamationView.prototype.showMessage = cleverapps.extendFunc(ExclamationView.prototype.showMessage, function (message, type, callback) {
    if (type === Exclamation.Types.Firework || type === Exclamation.Types.No_firework) {
        this.createAnimation(type === Exclamation.Types.Firework ? "firework" : "no_firework", callback);
        this.createMsg(message);
        return;
    }

    this._super(message, type, callback);
});

Exclamation.Types.Firework = 103;
Exclamation.Types.No_firework = 104;
